<template>
<el-card>
    <h1>合同签署成功通知</h1>
    <el-divider />
    <p class="p-title">
        <strong>接口说明：</strong>
    </p>
    <p>通过发起合同签署请求中的callbackUrl传过来，当合同签订后会以 POST 方式通过该地址将相关参数发送给用户 </p>
    <p class="p-title">
        <strong>参数说明：</strong>
    </p>
    <el-table size="mini" border :data="data">
        <el-table-column prop="name" label="模板参数名称" />
        <el-table-column prop="type" label="类型" />
        <el-table-column prop="desc" label="说明" />
    </el-table>
</el-card>
</template>

<script>
export default {
    components: {},
    data() {
        return {
          data:[
            {name:'contractId',type:'String',desc:'平台合同 ID'},
            {name:'businessId',type:'String',desc:'调用方标识，发起合同签署时的请求参数 businessId'},
            {name:'downloadUrl',type:'String',desc:'合同文件下载地址'},
          ]
        }
    }
};
</script>

<style scoped>
.el-card {
    margin: 0 20px
}
</style>
